import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';
import { useHomeData } from '@/hooks/useHomeData';
import { resolveImagePath } from '@/utils/imageMap';

export function About() {
  const { homeData } = useHomeData();

  return (
    <>
      <Helmet>
        <title>About Us - Our Team & Mission | Total Tailwheel</title>
        <meta
          name="description"
          content="Meet the Total Tailwheel team - Kevin Gilpin (Owner) and Matt Crane (CFI). Learn about our mission to provide authentic tailwheel training in our 1954 Cessna 170B."
        />
        <meta name="keywords" content="about total tailwheel, flight instructors, tailwheel training team, Kevin Gilpin, Matt Crane, CFI Massachusetts" />
        <meta property="og:title" content="About Us - Our Team & Mission | Total Tailwheel" />
        <meta property="og:description" content="Meet our team and learn about our mission to provide authentic tailwheel training in our restored 1954 Cessna 170B." />
        <link rel="canonical" href="https://totaltailwheel.com/about" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        
        <PageHero title="About Us" />


        {/* Team Section */}
        <section className="py-16 bg-secondary/10">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
              <h2 className="text-3xl font-medium text-primary text-center md:text-left mb-8">
                {homeData.team.title}
              </h2>
              <div className="space-y-8">
                {homeData.team.members.map((member, index) => (
                  <div key={index} className="p-6 border border-secondary/30 rounded-lg">
                    {member.image ? (
                      <div className="flex flex-col md:flex-row gap-6">
                        <div className="md:w-1/3">
                          <h3 className="text-xl font-medium text-primary mb-4">{member.name}</h3>
                          <img
                            src={resolveImagePath(member.image)}
                            alt={member.imageAlt || member.name}
                            className="w-full h-auto rounded-lg object-cover"
                          />
                        </div>
                        <div className="md:w-2/3">
                          <p className="text-foreground/80 leading-relaxed">{member.bio}</p>
                        </div>
                      </div>
                    ) : (
                      <>
                        <h3 className="text-xl font-medium text-primary mb-4">{member.name}</h3>
                        <p className="text-foreground/80 leading-relaxed">{member.bio}</p>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}